import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { AvatarDisplay } from 'avatar-components/AvatarDisplay';
import styled from 'foundations-theming-specialty/utils';
import { Timestamp } from './Timestamp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MessageContent = styled.div.withConfig({
  displayName: "MessageBubble__MessageContent"
})(["display:flex;flex-direction:column;gap:", ";block-size:100%;min-inline-size:0;overflow-wrap:anywhere;"], ({
  theme
}) => theme.space['200']);
export const MessageBubble = ({
  avatarUrl,
  displayName,
  header,
  timestamp,
  children
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "600",
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      blockSize: "fit-content",
      children: /*#__PURE__*/_jsx(AvatarDisplay, {
        type: "contact",
        src: avatarUrl !== null && avatarUrl !== void 0 ? avatarUrl : undefined,
        displayName: displayName !== null && displayName !== void 0 ? displayName : undefined,
        size: "md"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      flex: "1",
      minInlineSize: "0",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        gap: "200",
        alignItems: "baseline",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          children: header
        }), /*#__PURE__*/_jsx(Text, {
          typography: "detail-100",
          color: "text-core-default",
          "data-test-id": "thread-message-timestamp",
          children: /*#__PURE__*/_jsx(Timestamp, {
            timestamp: timestamp
          })
        })]
      }), /*#__PURE__*/_jsx(MessageContent, {
        children: children
      })]
    })]
  });
};